import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cockroach-root" }
const _hoisted_2 = {
  id: "road_zhanglang_b",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  class: "svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("svg", _hoisted_2, [
      _createVNode("path", {
        id: "road_zhanglang_b-2",
        "data-name": "road_zhanglang_b",
        d: "M.2,11A1.2,1.2,0,0,1-.649,8.951l9.6-9.6a1.2,1.2,0,0,1,1.7,1.7l-9.6,9.6A1.2,1.2,0,0,1,.2,11Z",
        transform: "translate(1 1)",
        fill: _ctx.mdata.type === 0 ? 'red' : 'blue'
      }, null, 8, ["fill"])
    ]))
  ]))
}